import { PropsWithChildren } from 'react'

type PanelSectionsProps = PropsWithChildren

const PanelSections = ({ children }: PanelSectionsProps) => {
  return (
    <div className="divide-y divide-gray-100">
      {children}
    </div>
  )
}

export default PanelSections
